var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import FrameView from './partials/FrameView';
import TileView from './partials/TileView';
import PhotoBoxView from './partials/PhotoBoxView';
import CanvasView from './partials/CanvasView';
import ContentLoader from '../../components/ContentLoader';
import { fetchProduct } from './store/actions';
import { createCartItem } from '../Cart/store/actions';
var mapStateToProps = function (state) { return ({
    item: state.products.item,
}); };
var mapDispatchToProps = {
    fetchProduct: fetchProduct,
    createCartItem: createCartItem,
};
var connector = connect(mapStateToProps, mapDispatchToProps);
var ProductView = /** @class */ (function (_super) {
    __extends(ProductView, _super);
    function ProductView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductView.prototype.componentDidMount = function () {
        this.props.fetchProduct(this.props.match.params.slug);
    };
    ProductView.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (prevProps.match.params.slug !== this.props.match.params.slug) {
            this.props.fetchProduct(this.props.match.params.slug);
        }
    };
    ProductView.prototype.render = function () {
        if ('loaded' !== this.props.item.status || !this.props.item.data) {
            return React.createElement(ContentLoader, null);
        }
        return (React.createElement("div", { className: "c-product-view" }, this.renderProductView()));
    };
    ProductView.prototype.renderProductView = function () {
        if (!this.props.item.data) {
            return null;
        }
        if (1 === this.props.item.data.id) {
            return React.createElement(FrameView, { item: this.props.item.data });
        }
        if (2 === this.props.item.data.id) {
            return React.createElement(TileView, { item: this.props.item.data });
        }
        if (3 === this.props.item.data.id) {
            return React.createElement(PhotoBoxView, { item: this.props.item.data });
        }
        if (4 === this.props.item.data.id) {
            return React.createElement(CanvasView, { item: this.props.item.data });
        }
        return null;
    };
    return ProductView;
}(React.Component));
export default connector(withRouter(withTranslation()(ProductView)));
